module.exports = __webpack_public_path__ + "img/Jack-Lubitz.1a82b581.jpg";